import { useTranslation } from 'react-i18next';
import { Lightbulb, MessageSquare } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FeatureRequestList } from '@/components/roadmap/FeatureRequestList';
import { FeedbackList } from '@/components/roadmap/FeedbackList';
import { PageHeader } from '@/components/PageHeader';

export default function Roadmap() {
  const { t } = useTranslation('roadmap');

  return (
    <div className="space-y-6">
      <PageHeader title={t('title')} subtitle={t('subtitle')} />

      <Tabs defaultValue="features" className="w-full">
        <TabsList>
          <TabsTrigger value="features" className="gap-1.5">
            <Lightbulb className="h-4 w-4" />
            {t('tabs.features')}
          </TabsTrigger>
          <TabsTrigger value="feedback" className="gap-1.5">
            <MessageSquare className="h-4 w-4" />
            {t('tabs.feedback')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="features" className="mt-4">
          <FeatureRequestList />
        </TabsContent>
        <TabsContent value="feedback" className="mt-4">
          <FeedbackList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
